import { __exports as w } from "../../../../_virtual/deflate.es2.js";
import { __require as Ha } from "../utils/common.es.js";
import { __require as Ba } from "./trees.es.js";
import { __require as qa } from "./adler32.es.js";
import { __require as Ua } from "./crc32.es.js";
import { __require as Ka } from "./messages.es.js";
var na;
function ja() {
  if (na) return w;
  na = 1;
  var g = Ha(), v = Ba(), W = qa(), b = Ua(), _a = Ka(), A = 0, ha = 1, la = 3, x = 4, j = 5, s = 0, $ = 1, c = -2, fa = -3, X = -5, da = -1, oa = 1, F = 2, ua = 3, ga = 4, va = 0, ca = 2, H = 8, pa = 9, wa = 15, sa = 8, ka = 29, za = 256, P = za + 1 + ka, ba = 30, xa = 19, Ea = 2 * P + 1, Sa = 15, h = 3, E = 258, p = E + h + 1, ma = 32, B = 42, Y = 69, q = 73, U = 91, K = 103, y = 113, M = 666, o = 1, N = 2, D = 3, I = 4, Ta = 3;
  function S(a, e) {
    return a.msg = _a[e], e;
  }
  function J(a) {
    return (a << 1) - (a > 4 ? 9 : 0);
  }
  function m(a) {
    for (var e = a.length; --e >= 0; )
      a[e] = 0;
  }
  function T(a) {
    var e = a.state, r = e.pending;
    r > a.avail_out && (r = a.avail_out), r !== 0 && (g.arraySet(a.output, e.pending_buf, e.pending_out, r, a.next_out), a.next_out += r, e.pending_out += r, a.total_out += r, a.avail_out -= r, e.pending -= r, e.pending === 0 && (e.pending_out = 0));
  }
  function u(a, e) {
    v._tr_flush_block(a, a.block_start >= 0 ? a.block_start : -1, a.strstart - a.block_start, e), a.block_start = a.strstart, T(a.strm);
  }
  function l(a, e) {
    a.pending_buf[a.pending++] = e;
  }
  function Z(a, e) {
    a.pending_buf[a.pending++] = e >>> 8 & 255, a.pending_buf[a.pending++] = e & 255;
  }
  function Aa(a, e, r, t) {
    var i = a.avail_in;
    return i > t && (i = t), i === 0 ? 0 : (a.avail_in -= i, g.arraySet(e, a.input, a.next_in, i, r), a.state.wrap === 1 ? a.adler = W(a.adler, e, i, r) : a.state.wrap === 2 && (a.adler = b(a.adler, e, i, r)), a.next_in += i, a.total_in += i, i);
  }
  function Q(a, e) {
    var r = a.max_chain_length, t = a.strstart, i, f, n = a.prev_length, _ = a.nice_match, z = a.strstart > a.w_size - p ? a.strstart - (a.w_size - p) : 0, d = a.window, C = a.w_mask, Fa = a.prev, V = a.strstart + E, ia = d[t + n - 1], ra = d[t + n];
    a.prev_length >= a.good_match && (r >>= 2), _ > a.lookahead && (_ = a.lookahead);
    do
      if (i = e, !(d[i + n] !== ra || d[i + n - 1] !== ia || d[i] !== d[t] || d[++i] !== d[t + 1])) {
        t += 2, i++;
        do
          ;
        while (d[++t] === d[++i] && d[++t] === d[++i] && d[++t] === d[++i] && d[++t] === d[++i] && d[++t] === d[++i] && d[++t] === d[++i] && d[++t] === d[++i] && d[++t] === d[++i] && t < V);
        if (f = E - (V - t), t = V - E, f > n) {
          if (a.match_start = e, n = f, f >= _)
            break;
          ia = d[t + n - 1], ra = d[t + n];
        }
      }
    while ((e = Fa[e & C]) > z && --r !== 0);
    return n <= a.lookahead ? n : a.lookahead;
  }
  function R(a) {
    var e = a.w_size, r, t, i, f, n;
    do {
      if (f = a.window_size - a.lookahead - a.strstart, a.strstart >= e + (e - p)) {
        g.arraySet(a.window, a.window, e, e, 0), a.match_start -= e, a.strstart -= e, a.block_start -= e, t = a.hash_size, r = t;
        do
          i = a.head[--r], a.head[r] = i >= e ? i - e : 0;
        while (--t);
        t = e, r = t;
        do
          i = a.prev[--r], a.prev[r] = i >= e ? i - e : 0;
        while (--t);
        f += e;
      }
      if (a.strm.avail_in === 0)
        break;
      if (t = Aa(a.strm, a.window, a.strstart + a.lookahead, f), a.lookahead += t, a.lookahead + a.insert >= h)
        for (n = a.strstart - a.insert, a.ins_h = a.window[n], a.ins_h = (a.ins_h << a.hash_shift ^ a.window[n + 1]) & a.hash_mask; a.insert && (a.ins_h = (a.ins_h << a.hash_shift ^ a.window[n + h - 1]) & a.hash_mask, a.prev[n & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = n, n++, a.insert--, !(a.lookahead + a.insert < h)); )
          ;
    } while (a.lookahead < p && a.strm.avail_in !== 0);
  }
  function ya(a, e) {
    var r = 65535;
    for (r > a.pending_buf_size - 5 && (r = a.pending_buf_size - 5); ; ) {
      if (a.lookahead <= 1) {
        if (R(a), a.lookahead === 0 && e === A)
          return o;
        if (a.lookahead === 0)
          break;
      }
      a.strstart += a.lookahead, a.lookahead = 0;
      var t = a.block_start + r;
      if ((a.strstart === 0 || a.strstart >= t) && (a.lookahead = a.strstart - t, a.strstart = t, u(a, !1), a.strm.avail_out === 0) || a.strstart - a.block_start >= a.w_size - p && (u(a, !1), a.strm.avail_out === 0))
        return o;
    }
    return a.insert = 0, e === x ? (u(a, !0), a.strm.avail_out === 0 ? D : I) : (a.strstart > a.block_start && (u(a, !1), a.strm.avail_out === 0), o);
  }
  function G(a, e) {
    for (var r, t; ; ) {
      if (a.lookahead < p) {
        if (R(a), a.lookahead < p && e === A)
          return o;
        if (a.lookahead === 0)
          break;
      }
      if (r = 0, a.lookahead >= h && (a.ins_h = (a.ins_h << a.hash_shift ^ a.window[a.strstart + h - 1]) & a.hash_mask, r = a.prev[a.strstart & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = a.strstart), r !== 0 && a.strstart - r <= a.w_size - p && (a.match_length = Q(a, r)), a.match_length >= h)
        if (t = v._tr_tally(a, a.strstart - a.match_start, a.match_length - h), a.lookahead -= a.match_length, a.match_length <= a.max_lazy_match && a.lookahead >= h) {
          a.match_length--;
          do
            a.strstart++, a.ins_h = (a.ins_h << a.hash_shift ^ a.window[a.strstart + h - 1]) & a.hash_mask, r = a.prev[a.strstart & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = a.strstart;
          while (--a.match_length !== 0);
          a.strstart++;
        } else
          a.strstart += a.match_length, a.match_length = 0, a.ins_h = a.window[a.strstart], a.ins_h = (a.ins_h << a.hash_shift ^ a.window[a.strstart + 1]) & a.hash_mask;
      else
        t = v._tr_tally(a, 0, a.window[a.strstart]), a.lookahead--, a.strstart++;
      if (t && (u(a, !1), a.strm.avail_out === 0))
        return o;
    }
    return a.insert = a.strstart < h - 1 ? a.strstart : h - 1, e === x ? (u(a, !0), a.strm.avail_out === 0 ? D : I) : a.last_lit && (u(a, !1), a.strm.avail_out === 0) ? o : N;
  }
  function O(a, e) {
    for (var r, t, i; ; ) {
      if (a.lookahead < p) {
        if (R(a), a.lookahead < p && e === A)
          return o;
        if (a.lookahead === 0)
          break;
      }
      if (r = 0, a.lookahead >= h && (a.ins_h = (a.ins_h << a.hash_shift ^ a.window[a.strstart + h - 1]) & a.hash_mask, r = a.prev[a.strstart & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = a.strstart), a.prev_length = a.match_length, a.prev_match = a.match_start, a.match_length = h - 1, r !== 0 && a.prev_length < a.max_lazy_match && a.strstart - r <= a.w_size - p && (a.match_length = Q(a, r), a.match_length <= 5 && (a.strategy === oa || a.match_length === h && a.strstart - a.match_start > 4096) && (a.match_length = h - 1)), a.prev_length >= h && a.match_length <= a.prev_length) {
        i = a.strstart + a.lookahead - h, t = v._tr_tally(a, a.strstart - 1 - a.prev_match, a.prev_length - h), a.lookahead -= a.prev_length - 1, a.prev_length -= 2;
        do
          ++a.strstart <= i && (a.ins_h = (a.ins_h << a.hash_shift ^ a.window[a.strstart + h - 1]) & a.hash_mask, r = a.prev[a.strstart & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = a.strstart);
        while (--a.prev_length !== 0);
        if (a.match_available = 0, a.match_length = h - 1, a.strstart++, t && (u(a, !1), a.strm.avail_out === 0))
          return o;
      } else if (a.match_available) {
        if (t = v._tr_tally(a, 0, a.window[a.strstart - 1]), t && u(a, !1), a.strstart++, a.lookahead--, a.strm.avail_out === 0)
          return o;
      } else
        a.match_available = 1, a.strstart++, a.lookahead--;
    }
    return a.match_available && (t = v._tr_tally(a, 0, a.window[a.strstart - 1]), a.match_available = 0), a.insert = a.strstart < h - 1 ? a.strstart : h - 1, e === x ? (u(a, !0), a.strm.avail_out === 0 ? D : I) : a.last_lit && (u(a, !1), a.strm.avail_out === 0) ? o : N;
  }
  function Da(a, e) {
    for (var r, t, i, f, n = a.window; ; ) {
      if (a.lookahead <= E) {
        if (R(a), a.lookahead <= E && e === A)
          return o;
        if (a.lookahead === 0)
          break;
      }
      if (a.match_length = 0, a.lookahead >= h && a.strstart > 0 && (i = a.strstart - 1, t = n[i], t === n[++i] && t === n[++i] && t === n[++i])) {
        f = a.strstart + E;
        do
          ;
        while (t === n[++i] && t === n[++i] && t === n[++i] && t === n[++i] && t === n[++i] && t === n[++i] && t === n[++i] && t === n[++i] && i < f);
        a.match_length = E - (f - i), a.match_length > a.lookahead && (a.match_length = a.lookahead);
      }
      if (a.match_length >= h ? (r = v._tr_tally(a, 1, a.match_length - h), a.lookahead -= a.match_length, a.strstart += a.match_length, a.match_length = 0) : (r = v._tr_tally(a, 0, a.window[a.strstart]), a.lookahead--, a.strstart++), r && (u(a, !1), a.strm.avail_out === 0))
        return o;
    }
    return a.insert = 0, e === x ? (u(a, !0), a.strm.avail_out === 0 ? D : I) : a.last_lit && (u(a, !1), a.strm.avail_out === 0) ? o : N;
  }
  function Ra(a, e) {
    for (var r; ; ) {
      if (a.lookahead === 0 && (R(a), a.lookahead === 0)) {
        if (e === A)
          return o;
        break;
      }
      if (a.match_length = 0, r = v._tr_tally(a, 0, a.window[a.strstart]), a.lookahead--, a.strstart++, r && (u(a, !1), a.strm.avail_out === 0))
        return o;
    }
    return a.insert = 0, e === x ? (u(a, !0), a.strm.avail_out === 0 ? D : I) : a.last_lit && (u(a, !1), a.strm.avail_out === 0) ? o : N;
  }
  function k(a, e, r, t, i) {
    this.good_length = a, this.max_lazy = e, this.nice_length = r, this.max_chain = t, this.func = i;
  }
  var L;
  L = [
    /*      good lazy nice chain */
    new k(0, 0, 0, 0, ya),
    /* 0 store only */
    new k(4, 4, 8, 4, G),
    /* 1 max speed, no lazy matches */
    new k(4, 5, 16, 8, G),
    /* 2 */
    new k(4, 6, 32, 32, G),
    /* 3 */
    new k(4, 4, 16, 16, O),
    /* 4 lazy matches */
    new k(8, 16, 32, 32, O),
    /* 5 */
    new k(8, 16, 128, 128, O),
    /* 6 */
    new k(8, 32, 128, 256, O),
    /* 7 */
    new k(32, 128, 258, 1024, O),
    /* 8 */
    new k(32, 258, 258, 4096, O)
    /* 9 max compression */
  ];
  function Ia(a) {
    a.window_size = 2 * a.w_size, m(a.head), a.max_lazy_match = L[a.level].max_lazy, a.good_match = L[a.level].good_length, a.nice_match = L[a.level].nice_length, a.max_chain_length = L[a.level].max_chain, a.strstart = 0, a.block_start = 0, a.lookahead = 0, a.insert = 0, a.match_length = a.prev_length = h - 1, a.match_available = 0, a.ins_h = 0;
  }
  function Oa() {
    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = H, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new g.Buf16(Ea * 2), this.dyn_dtree = new g.Buf16((2 * ba + 1) * 2), this.bl_tree = new g.Buf16((2 * xa + 1) * 2), m(this.dyn_ltree), m(this.dyn_dtree), m(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new g.Buf16(Sa + 1), this.heap = new g.Buf16(2 * P + 1), m(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new g.Buf16(2 * P + 1), m(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
  }
  function aa(a) {
    var e;
    return !a || !a.state ? S(a, c) : (a.total_in = a.total_out = 0, a.data_type = ca, e = a.state, e.pending = 0, e.pending_out = 0, e.wrap < 0 && (e.wrap = -e.wrap), e.status = e.wrap ? B : y, a.adler = e.wrap === 2 ? 0 : 1, e.last_flush = A, v._tr_init(e), s);
  }
  function ta(a) {
    var e = aa(a);
    return e === s && Ia(a.state), e;
  }
  function La(a, e) {
    return !a || !a.state || a.state.wrap !== 2 ? c : (a.state.gzhead = e, s);
  }
  function ea(a, e, r, t, i, f) {
    if (!a)
      return c;
    var n = 1;
    if (e === da && (e = 6), t < 0 ? (n = 0, t = -t) : t > 15 && (n = 2, t -= 16), i < 1 || i > pa || r !== H || t < 8 || t > 15 || e < 0 || e > 9 || f < 0 || f > ga)
      return S(a, c);
    t === 8 && (t = 9);
    var _ = new Oa();
    return a.state = _, _.strm = a, _.wrap = n, _.gzhead = null, _.w_bits = t, _.w_size = 1 << _.w_bits, _.w_mask = _.w_size - 1, _.hash_bits = i + 7, _.hash_size = 1 << _.hash_bits, _.hash_mask = _.hash_size - 1, _.hash_shift = ~~((_.hash_bits + h - 1) / h), _.window = new g.Buf8(_.w_size * 2), _.head = new g.Buf16(_.hash_size), _.prev = new g.Buf16(_.w_size), _.lit_bufsize = 1 << i + 6, _.pending_buf_size = _.lit_bufsize * 4, _.pending_buf = new g.Buf8(_.pending_buf_size), _.d_buf = 1 * _.lit_bufsize, _.l_buf = 3 * _.lit_bufsize, _.level = e, _.strategy = f, _.method = r, ta(a);
  }
  function Ma(a, e) {
    return ea(a, e, H, wa, sa, va);
  }
  function Na(a, e) {
    var r, t, i, f;
    if (!a || !a.state || e > j || e < 0)
      return a ? S(a, c) : c;
    if (t = a.state, !a.output || !a.input && a.avail_in !== 0 || t.status === M && e !== x)
      return S(a, a.avail_out === 0 ? X : c);
    if (t.strm = a, r = t.last_flush, t.last_flush = e, t.status === B)
      if (t.wrap === 2)
        a.adler = 0, l(t, 31), l(t, 139), l(t, 8), t.gzhead ? (l(
          t,
          (t.gzhead.text ? 1 : 0) + (t.gzhead.hcrc ? 2 : 0) + (t.gzhead.extra ? 4 : 0) + (t.gzhead.name ? 8 : 0) + (t.gzhead.comment ? 16 : 0)
        ), l(t, t.gzhead.time & 255), l(t, t.gzhead.time >> 8 & 255), l(t, t.gzhead.time >> 16 & 255), l(t, t.gzhead.time >> 24 & 255), l(t, t.level === 9 ? 2 : t.strategy >= F || t.level < 2 ? 4 : 0), l(t, t.gzhead.os & 255), t.gzhead.extra && t.gzhead.extra.length && (l(t, t.gzhead.extra.length & 255), l(t, t.gzhead.extra.length >> 8 & 255)), t.gzhead.hcrc && (a.adler = b(a.adler, t.pending_buf, t.pending, 0)), t.gzindex = 0, t.status = Y) : (l(t, 0), l(t, 0), l(t, 0), l(t, 0), l(t, 0), l(t, t.level === 9 ? 2 : t.strategy >= F || t.level < 2 ? 4 : 0), l(t, Ta), t.status = y);
      else {
        var n = H + (t.w_bits - 8 << 4) << 8, _ = -1;
        t.strategy >= F || t.level < 2 ? _ = 0 : t.level < 6 ? _ = 1 : t.level === 6 ? _ = 2 : _ = 3, n |= _ << 6, t.strstart !== 0 && (n |= ma), n += 31 - n % 31, t.status = y, Z(t, n), t.strstart !== 0 && (Z(t, a.adler >>> 16), Z(t, a.adler & 65535)), a.adler = 1;
      }
    if (t.status === Y)
      if (t.gzhead.extra) {
        for (i = t.pending; t.gzindex < (t.gzhead.extra.length & 65535) && !(t.pending === t.pending_buf_size && (t.gzhead.hcrc && t.pending > i && (a.adler = b(a.adler, t.pending_buf, t.pending - i, i)), T(a), i = t.pending, t.pending === t.pending_buf_size)); )
          l(t, t.gzhead.extra[t.gzindex] & 255), t.gzindex++;
        t.gzhead.hcrc && t.pending > i && (a.adler = b(a.adler, t.pending_buf, t.pending - i, i)), t.gzindex === t.gzhead.extra.length && (t.gzindex = 0, t.status = q);
      } else
        t.status = q;
    if (t.status === q)
      if (t.gzhead.name) {
        i = t.pending;
        do {
          if (t.pending === t.pending_buf_size && (t.gzhead.hcrc && t.pending > i && (a.adler = b(a.adler, t.pending_buf, t.pending - i, i)), T(a), i = t.pending, t.pending === t.pending_buf_size)) {
            f = 1;
            break;
          }
          t.gzindex < t.gzhead.name.length ? f = t.gzhead.name.charCodeAt(t.gzindex++) & 255 : f = 0, l(t, f);
        } while (f !== 0);
        t.gzhead.hcrc && t.pending > i && (a.adler = b(a.adler, t.pending_buf, t.pending - i, i)), f === 0 && (t.gzindex = 0, t.status = U);
      } else
        t.status = U;
    if (t.status === U)
      if (t.gzhead.comment) {
        i = t.pending;
        do {
          if (t.pending === t.pending_buf_size && (t.gzhead.hcrc && t.pending > i && (a.adler = b(a.adler, t.pending_buf, t.pending - i, i)), T(a), i = t.pending, t.pending === t.pending_buf_size)) {
            f = 1;
            break;
          }
          t.gzindex < t.gzhead.comment.length ? f = t.gzhead.comment.charCodeAt(t.gzindex++) & 255 : f = 0, l(t, f);
        } while (f !== 0);
        t.gzhead.hcrc && t.pending > i && (a.adler = b(a.adler, t.pending_buf, t.pending - i, i)), f === 0 && (t.status = K);
      } else
        t.status = K;
    if (t.status === K && (t.gzhead.hcrc ? (t.pending + 2 > t.pending_buf_size && T(a), t.pending + 2 <= t.pending_buf_size && (l(t, a.adler & 255), l(t, a.adler >> 8 & 255), a.adler = 0, t.status = y)) : t.status = y), t.pending !== 0) {
      if (T(a), a.avail_out === 0)
        return t.last_flush = -1, s;
    } else if (a.avail_in === 0 && J(e) <= J(r) && e !== x)
      return S(a, X);
    if (t.status === M && a.avail_in !== 0)
      return S(a, X);
    if (a.avail_in !== 0 || t.lookahead !== 0 || e !== A && t.status !== M) {
      var z = t.strategy === F ? Ra(t, e) : t.strategy === ua ? Da(t, e) : L[t.level].func(t, e);
      if ((z === D || z === I) && (t.status = M), z === o || z === D)
        return a.avail_out === 0 && (t.last_flush = -1), s;
      if (z === N && (e === ha ? v._tr_align(t) : e !== j && (v._tr_stored_block(t, 0, 0, !1), e === la && (m(t.head), t.lookahead === 0 && (t.strstart = 0, t.block_start = 0, t.insert = 0))), T(a), a.avail_out === 0))
        return t.last_flush = -1, s;
    }
    return e !== x ? s : t.wrap <= 0 ? $ : (t.wrap === 2 ? (l(t, a.adler & 255), l(t, a.adler >> 8 & 255), l(t, a.adler >> 16 & 255), l(t, a.adler >> 24 & 255), l(t, a.total_in & 255), l(t, a.total_in >> 8 & 255), l(t, a.total_in >> 16 & 255), l(t, a.total_in >> 24 & 255)) : (Z(t, a.adler >>> 16), Z(t, a.adler & 65535)), T(a), t.wrap > 0 && (t.wrap = -t.wrap), t.pending !== 0 ? s : $);
  }
  function Za(a) {
    var e;
    return !a || !a.state ? c : (e = a.state.status, e !== B && e !== Y && e !== q && e !== U && e !== K && e !== y && e !== M ? S(a, c) : (a.state = null, e === y ? S(a, fa) : s));
  }
  function Ca(a, e) {
    var r = e.length, t, i, f, n, _, z, d, C;
    if (!a || !a.state || (t = a.state, n = t.wrap, n === 2 || n === 1 && t.status !== B || t.lookahead))
      return c;
    for (n === 1 && (a.adler = W(a.adler, e, r, 0)), t.wrap = 0, r >= t.w_size && (n === 0 && (m(t.head), t.strstart = 0, t.block_start = 0, t.insert = 0), C = new g.Buf8(t.w_size), g.arraySet(C, e, r - t.w_size, t.w_size, 0), e = C, r = t.w_size), _ = a.avail_in, z = a.next_in, d = a.input, a.avail_in = r, a.next_in = 0, a.input = e, R(t); t.lookahead >= h; ) {
      i = t.strstart, f = t.lookahead - (h - 1);
      do
        t.ins_h = (t.ins_h << t.hash_shift ^ t.window[i + h - 1]) & t.hash_mask, t.prev[i & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = i, i++;
      while (--f);
      t.strstart = i, t.lookahead = h - 1, R(t);
    }
    return t.strstart += t.lookahead, t.block_start = t.strstart, t.insert = t.lookahead, t.lookahead = 0, t.match_length = t.prev_length = h - 1, t.match_available = 0, a.next_in = z, a.input = d, a.avail_in = _, t.wrap = n, s;
  }
  return w.deflateInit = Ma, w.deflateInit2 = ea, w.deflateReset = ta, w.deflateResetKeep = aa, w.deflateSetHeader = La, w.deflate = Na, w.deflateEnd = Za, w.deflateSetDictionary = Ca, w.deflateInfo = "pako deflate (from Nodeca project)", w;
}
export {
  ja as __require
};
//# sourceMappingURL=deflate.es.js.map
